/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createEstimatedBasicCost } from '../fn/estimated-basic-cost/create-estimated-basic-cost';
import { CreateEstimatedBasicCost$Params } from '../fn/estimated-basic-cost/create-estimated-basic-cost';
import { deleteEstimatedBasicCost } from '../fn/estimated-basic-cost/delete-estimated-basic-cost';
import { DeleteEstimatedBasicCost$Params } from '../fn/estimated-basic-cost/delete-estimated-basic-cost';
import { EstimatedBasicCostDto } from '../models/estimated-basic-cost-dto';
import { EstimatedBasicCostDtoPage } from '../models/estimated-basic-cost-dto-page';
import { getEstimatedBasicCost } from '../fn/estimated-basic-cost/get-estimated-basic-cost';
import { GetEstimatedBasicCost$Params } from '../fn/estimated-basic-cost/get-estimated-basic-cost';
import { listEstimatedBasicCosts } from '../fn/estimated-basic-cost/list-estimated-basic-costs';
import { ListEstimatedBasicCosts$Params } from '../fn/estimated-basic-cost/list-estimated-basic-costs';
import { previewEstimatedBasicCost } from '../fn/estimated-basic-cost/preview-estimated-basic-cost';
import { PreviewEstimatedBasicCost$Params } from '../fn/estimated-basic-cost/preview-estimated-basic-cost';
import { PreviewEstimatedBasicCostDto } from '../models/preview-estimated-basic-cost-dto';
import { updateEstimatedBasicCost } from '../fn/estimated-basic-cost/update-estimated-basic-cost';
import { UpdateEstimatedBasicCost$Params } from '../fn/estimated-basic-cost/update-estimated-basic-cost';

@Injectable({ providedIn: 'root' })
export class EstimatedBasicCostApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listEstimatedBasicCosts()` */
  static readonly ListEstimatedBasicCostsPath = '/v0/estimatedBasicCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listEstimatedBasicCosts()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedBasicCosts$Response(params?: ListEstimatedBasicCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedBasicCostDtoPage>> {
    return listEstimatedBasicCosts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listEstimatedBasicCosts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listEstimatedBasicCosts(params?: ListEstimatedBasicCosts$Params, context?: HttpContext): Observable<EstimatedBasicCostDtoPage> {
    return this.listEstimatedBasicCosts$Response(params, context).pipe(
      map((r: StrictHttpResponse<EstimatedBasicCostDtoPage>): EstimatedBasicCostDtoPage => r.body)
    );
  }

  /** Path part for operation `createEstimatedBasicCost()` */
  static readonly CreateEstimatedBasicCostPath = '/v0/estimatedBasicCost';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createEstimatedBasicCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEstimatedBasicCost$Response(params: CreateEstimatedBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return createEstimatedBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createEstimatedBasicCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createEstimatedBasicCost(params: CreateEstimatedBasicCost$Params, context?: HttpContext): Observable<string> {
    return this.createEstimatedBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getEstimatedBasicCost()` */
  static readonly GetEstimatedBasicCostPath = '/v0/estimatedBasicCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstimatedBasicCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedBasicCost$Response(params: GetEstimatedBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedBasicCostDto>> {
    return getEstimatedBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEstimatedBasicCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedBasicCost(params: GetEstimatedBasicCost$Params, context?: HttpContext): Observable<EstimatedBasicCostDto> {
    return this.getEstimatedBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<EstimatedBasicCostDto>): EstimatedBasicCostDto => r.body)
    );
  }

  /** Path part for operation `updateEstimatedBasicCost()` */
  static readonly UpdateEstimatedBasicCostPath = '/v0/estimatedBasicCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateEstimatedBasicCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEstimatedBasicCost$Response(params: UpdateEstimatedBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return updateEstimatedBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateEstimatedBasicCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateEstimatedBasicCost(params: UpdateEstimatedBasicCost$Params, context?: HttpContext): Observable<string> {
    return this.updateEstimatedBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `deleteEstimatedBasicCost()` */
  static readonly DeleteEstimatedBasicCostPath = '/v0/estimatedBasicCost/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteEstimatedBasicCost()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEstimatedBasicCost$Response(params: DeleteEstimatedBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteEstimatedBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteEstimatedBasicCost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteEstimatedBasicCost(params: DeleteEstimatedBasicCost$Params, context?: HttpContext): Observable<void> {
    return this.deleteEstimatedBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `previewEstimatedBasicCost()` */
  static readonly PreviewEstimatedBasicCostPath = '/v0/estimatedBasicCost/preview';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `previewEstimatedBasicCost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  previewEstimatedBasicCost$Response(params: PreviewEstimatedBasicCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PreviewEstimatedBasicCostDto>> {
    return previewEstimatedBasicCost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `previewEstimatedBasicCost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  previewEstimatedBasicCost(params: PreviewEstimatedBasicCost$Params, context?: HttpContext): Observable<PreviewEstimatedBasicCostDto> {
    return this.previewEstimatedBasicCost$Response(params, context).pipe(
      map((r: StrictHttpResponse<PreviewEstimatedBasicCostDto>): PreviewEstimatedBasicCostDto => r.body)
    );
  }

}
